// extracted by mini-css-extract-plugin
module.exports = {"list":"BreadCrumbs_list__rosqJ","item":"BreadCrumbs_item__d6FXE","link":"BreadCrumbs_link__judCI","last":"BreadCrumbs_last__Fn6uu","load":"BreadCrumbs_load___axQW"};